import React from 'react';
export default (function (_ref) {
  var variableName = _ref.variableName,
    value = _ref.value;
  return /*#__PURE__*/React.createElement("style", null, ":root{--".concat(variableName, ":").concat(value, "px;}"));
});